// This needs to be brought somewhere else but it essentially
// allows you to use either render props, function as child or
// just children. This is super helpful in libraries where you
// want to allow a component to offer all of the various usage
// syntaxes.
var simpleRender = function simpleRender(props, renderCallback, emptyCallback) {
    // Allow render prop or function as a child
    var children = props.children,
        _props$render = props.render,
        render = _props$render === undefined ? children : _props$render;

    // RENDER PROPS OR FAAC

    if (typeof render === "function") {
        return renderCallback(function (output) {
            return render(output);
        });
    }

    // EMPTY
    if (!children && typeof emptyCallback === "function") {
        return emptyCallback();
    }

    //  CHILDREN
    return renderCallback(function () {
        return children;
    });
};

export default simpleRender;